var cloneDeep = require('lodash/cloneDeep');

// Helper to enforce component attributes sort order
let attributesSortOrder = {
    TEXT: {
        FREETEXT: 0,
        PLACEMENT: 1,
        FONT: 2,
        COLOR: 3
    }
};

/**
 * Configuration object for each component type, holds selectors of the elements that will become enabled/disabled
 * as the user completes the option form
 */
let formsConfigurations = {
    TEXT: [{
        id: 'FREETEXT',
        selector: '.form-floating'
    },
    {
        id: 'PLACEMENT',
        selector: '.common-selection-location'
    },
    {
        id: 'FONT',
        selector: '.font-selection-box'
    },
    {
        id: 'COLOR',
        selector: '.color-selection-box'
    }],
    STOCK: [{
        id: 'DESIGN',
        selector: '.stock-designs-capsule'
    },
    {
        id: 'PLACEMENT',
        selector: '.common-selection-location'
    },
    {
        id: 'POSITIONING',
        selector: '.position-selection-box'
    }],
    FLAG: [{
        id: 'DESIGN',
        selector: '.flag-selection-capsule'
    },
    {
        id: 'PLACEMENT',
        selector: '.common-selection-location'
    },
    {
        id: 'SIZE',
        selector: '.flag-size-selection-block'
    },
    {
        id: 'POSITIONING',
        selector: '.position-selection-box'
    }],
    CUSTOMLOGO: [{
        id: 'LOGO NAME',
        selector: '.logo-list-wrapper'
    },
    {
        id: 'LOGO NUMBER',
        selector: '.logoGUID'
    },
    {
        id: 'PLACEMENT',
        selector: '.common-selection-location'
    },
    {
        id: 'POSITIONING',
        selector: '.position-selection-box'
    }],
    COMMENTS: [{
        id: 'TEXT',
        selector: '.summary-comment-textarea'
    }]
};

// Class representing an embroidery component that will be sent to cart (Text, stock, flag etc)
class EmbroideryComponent {
    constructor(config) {
        this.component = config.componentId || config.component;
        this.uid = Math.random().toString(36).slice(2);
        this.componentAttributes = config.componentAttributes && config.componentAttributes.length ? config.componentAttributes : [];
    }

    /**
     * Resets all attribute values for this option
     */
    reset() {
        // Reset attribute values, trigger field update in the DOM with empty value, and removes data
        if (this.componentAttributes.length) {
            let length = this.componentAttributes.length;

            // update() with value '' removes a key by index
            // in this case reset() will cause a shift() for each element
            for (let i = 0; i < length; i++) {
                this.update(this.componentAttributes[0].componentAttribute, '');
            }

            this.componentAttributes = [];
        }
    }

    reload() {
        if (this.componentAttributes.length) {
            for (let i = 0; i < this.componentAttributes.length; i++) {
                const attribute = this.componentAttributes[i];
                this.update(attribute.componentAttribute, attribute.attributeValue);
            }
        }
    }

    /**
    * Update an attribute value
    * Merge attributes from configuration to keep all data in one place (Ex 'valueHexCode', 'webDisplayValue' etc)
    * @param {string} key - attribute 'componentAttribute' key
    * @param {string} value -  attribute 'attributeValue' value
    * @param {Object} params -  collection of additional poperties to add to component attribute
    */
    update(key, value, params) {
        // Update a current attribute data, or create a new attribute for the option
        let currentIndex = this.componentAttributes.findIndex(x => x.componentAttribute === key);
        // Get the configuration attributes for this component (Ex: TEXT)
        let componentData = window.store.globals.componentsData[this.component];

        if (componentData) {
            // Get the configuration attributes for this attribute (Ex: FONT)
            let attributeModel = componentData.componentAttributes[key];
            let optionData = {};
            let updatedAttribute = {};

            // If has value
            if (value) {
                // If option has options with data defined, pick up the data for the selected option
                if (attributeModel && attributeModel.optionValues) {
                    optionData = attributeModel && attributeModel.optionValues.find(option => option.valueId === value);
                }

                updatedAttribute = cloneDeep(optionData);
                delete updatedAttribute.valueId;
                updatedAttribute.attributeValue = value;
                updatedAttribute.componentAttribute = key;

                // Push any extra properties on the component attribute
                if (params) {
                    let keys = Object.keys(params);
                    for (let i = 0; i < keys.length; i++) {
                        const customKey = keys[i];
                        const customValue = params[customKey];
                        updatedAttribute[customKey] = customValue;
                    }
                }

                if (!~currentIndex) {
                    // Clone the configuration attributes, modify the attributes needed for export (value, type), and merge everything

                    if (attributesSortOrder[componentData.componentId] && attributesSortOrder[componentData.componentId][updatedAttribute.componentAttribute] !== undefined) {
                        // If sort order defined inject attribute at position per design
                        this.componentAttributes.splice(attributesSortOrder[componentData.componentId][updatedAttribute.componentAttribute], 0, updatedAttribute);
                    } else {
                        // No ordering
                        this.componentAttributes.push(updatedAttribute);
                    }
                } else {
                    this.componentAttributes.splice(currentIndex, 1, updatedAttribute);
                }

                // remove position if PLACEMENT set/changed
                if (key === 'PLACEMENT') {
                    this.componentAttributes = this.componentAttributes.filter(attr => attr.componentAttribute !== 'POSITIONING');
                    $(document).trigger('embroidery:updateField', {
                        key: 'POSITIONING',
                        value: '',
                        id: this.uid,
                        attribute: {
                            attributeValue: '',
                            valueDesc: '',
                            componentAttribute: 'POSITIONING'
                        },
                        componentData
                    });
                }
            } else if (this.componentAttributes[currentIndex] !== undefined) {
                // Remove element for no value
                this.componentAttributes.splice(currentIndex, 1);
                updatedAttribute.attributeValue = value;
                updatedAttribute.componentAttribute = key;
            }

            // Trigger the update of the respective field in the DOM
            $(document).trigger('embroidery:updateField', {
                key,
                value,
                id: this.uid,
                attribute: updatedAttribute,
                componentData
            });

            if (key !== 'PLACEMENT') {
                // Click Placement button if there is only one option
                let $embroideryComponentLine = $(`.embroidery-component-line[data-component-id="${this.uid}"]`);
                let $locationBtns = $embroideryComponentLine.find('.common-selection-location-wrapper');
                if ($locationBtns && $locationBtns.children().length === 1 && !$locationBtns.hasClass('disabled') && !$locationBtns.hasClass('selected')) {
                    $locationBtns.children().first().trigger('click');
                }
            }
        }
    }

    updateAll(componentAttributes) {
        // If receiving an empty value array, assume we should reset the form
        if (!componentAttributes.length) {
            this.reset();
        } else {
            componentAttributes.forEach(attribute => {
                // If attribute has extra properties besides main values send everything to update
                let additionalProps = Object.keys(attribute).length > 2 ? attribute : {};
                this.update(attribute.componentAttribute, attribute.attributeValue, additionalProps);
            });
        }
    }

    /**
     * Returns a specified attribute data for this embroidery component
     * @param {string} attributeName - attribute Name
     * @returns {Object} - the attribute data object
     */
    getAttribute(attributeName) {
        return this.componentAttributes.find(attribute => attribute.componentAttribute === attributeName);
    }
}

// Class representing the embroidery data object that will be passed to cart
class EmbroideryData {
    constructor() {
        this.data = [];
    }

    /**
     * Returns a embroidery component by id
     * @param {string} id - The uid of the component
     * @returns {Object} The component for this option (text, font, etc)
     */
    getComponent(id) {
        return id && this.data.find(x => x.uid === id.toString());
    }

    /**
     * Deletes a component from data
     * @param {string} id - The uid of the component
     */
    delete(id) {
        let i = this.data.findIndex(componentData => componentData.uid === id);
        if (~i) {
            this.data.splice(i, 1);
        }
    }

    /**
     * Creates a new component
     * @param {Object} data - The data for the option object
     * @returns {Object} The component added
     */
    addComponent(data) {
        let component = new EmbroideryComponent(data);
        this.data.push(component);
        $(document).trigger('embroidery:componentCreated');
        return component;
    }

    removeComponent(uid) {
        let i = this.data.findIndex(x => x.uid === uid);
        if (~i) {
            this.data.splice(i, 1);
        }
    }
}

// Class representing the 'step' (form field). Has information for the form field, the wrapper that gets styled, and additional data
class EmbroideryFormField {
    constructor(config) {
        this.id = config.id;
        this.selector = config.selector;
        this.$el = config.$el;
        this.$wrapper = config.$wrapper;
        this.complete = false;
        this.required = this.id !== 'POSITIONING';
        this.error = {
            state: false,
            msg: ''
        };
        this.warning = {
            state: false,
            msg: ''
        };
    }

    setError(msg = '') {
        this.error.msg = msg;
        this.error.state = true;
        this.$wrapper.addClass('issue-error').find('.error-box').text(msg);
        if (!this.$wrapper.children('figure').length) {
            let errorEl = $('<figure></figure>').text('Please complete this section').addClass('error-instruct');
            this.$wrapper.append(errorEl);
        }
    }

    setWarning(msg = '') {
        this.warning.msg = msg;
        this.warning.state = true;
        this.$wrapper.addClass('issue-warning').find('.error-box').text(msg);
    }

    clearError() {
        this.error = {
            state: false,
            msg: ''
        };
        this.warning = {
            state: false,
            msg: ''
        };

        this.$wrapper.removeClass('issue-error issue-warning');
        this.$wrapper.children('.error-instruct').remove();
    }

    reset() {
        this.clearError();
        this.complete = false;
        if (this.id === 'POSITIONING') {
            this.required = false;
            if (this.$wrapper && this.$wrapper.length) {
                this.$wrapper.addClass('d-none');
            }
        }
    }
}

// Class representing a component form/embroidery line (a text line, a stock line, etc). There can be multiple lines of the same type
class EmbroideryForm {
    constructor(id, steps, $el) {
        this.id = id;
        this.steps = steps && steps.length
            ? steps.map(step => {
                return new EmbroideryFormField({
                    id: step.id,
                    selector: step.selector,
                    $el: $(`[data-model="${step.id}"][data-component-id="${id}"]`),
                    $wrapper: $el.find(step.selector)
                });
            })
            : [];

        this.complete = false;
        this.untouched = true;
        this.$el = $el;
    }

    get untouched() {
        return this.steps.every(step => !step.complete);
    }

    get hasWarning() {
        let hasWarning = false;

        for (let i = 0; i < this.steps.length; i++) {
            const field = this.steps[i];

            if (field.warning.state) {
                hasWarning = true;
            }
        }

        return hasWarning;
    }

    get hasError() {
        let hasError = false;

        for (let i = 0; i < this.steps.length; i++) {
            const field = this.steps[i];

            if (field.error.state) {
                hasError = true;
            }
        }

        return hasError;
    }

    /**
     * A form is complete if all fields are complete
     */
    get complete() {
        return this.steps.every(step => step.complete || !step.required);
    }

    reset() {
        this.steps.forEach(step => {
            step.reset();
        });

        this.updateFieldsAvailability();
    }

    setComplete(step, state) {
        this.steps.find(x => x.id === step).complete = state;
        this.updateFieldsAvailability();
    }

    /**
    * Sets embroidery form fields as enabled/disabled depending on where the user is in the form
    * @param {Array} arr - the steps array
    * @param {number} i - the current step
    */
    updateFieldsAvailability() {
        let hasIncompleteStep = false;

        for (let index = 0; index < this.steps.length; index++) {
            const step = this.steps[index];

            step.$wrapper.toggleClass('disabled', hasIncompleteStep);

            step.$wrapper.find('input').prop('disabled', hasIncompleteStep);

            if (step.$wrapper.is('input')) {
                step.$wrapper.closest('.disabled').removeClass('disabled');
            }

            if (!step.complete && !hasIncompleteStep && step.required) {
                hasIncompleteStep = true;
                this.$el.attr('data-step', index);
            }
        }

        if (!hasIncompleteStep) {
            this.$el.attr('data-step', 'complete');
        }

        this.$el.attr('data-complete-steps', this.steps.filter(step => step.complete === true).length);
    }

    clearErrors() {
        this.steps.forEach(step => {
            step.clearError();
        });
    }
}

// Class representing an embroidery option like text or stock. It can hold multiple forms (lines) of the same embroidery option.
class EmbroideryFormSection {
    constructor($el, sectionType) {
        this.forms = {};
        this.type = sectionType;
        this.$el = $el;
        this.disabled = false;
    }

    /**
     * Check all forms are complete and there are no reported errors
     */
    get valid() {
        let keys = Object.keys(this.forms);
        let valid = true;

        if (keys.length) {
            for (let i = 0; i < keys.length; i++) {
                const form = this.forms[keys[i]];

                if (!form.complete) {
                    valid = false;
                }
            }
        } else {
            valid = false;
        }

        if (this.hasError) {
            valid = false;
        }

        return valid;
    }

    /**
     * Checks none of the forms have warnings
     */
    get hasWarning() {
        let keys = Object.keys(this.forms);
        let hasWarning = false;

        for (let i = 0; i < keys.length; i++) {
            const form = this.forms[keys[i]];

            if (form.hasWarning) {
                hasWarning = true;
            }
        }

        return hasWarning;
    }

    /**
     * Checks none of the forms have errors
     */
    get hasError() {
        let keys = Object.keys(this.forms);
        let hasError = false;

        for (let i = 0; i < keys.length; i++) {
            const form = this.forms[keys[i]];

            if (form.hasError) {
                hasError = true;
            }
        }

        return hasError;
    }

    /**
     * A section is untouched if all fields in all forms are not complete
     */
    get untouched() {
        let keys = Object.keys(this.forms);
        let untouched = true;

        for (let i = 0; i < keys.length; i++) {
            const form = this.forms[keys[i]];

            if (!form.steps.every(step => !step.complete)) {
                untouched = false;
            }
        }

        return untouched;
    }

    addForm(config) {
        this.forms[config.id] = new EmbroideryForm(config);
    }

    registerForm(componentData, $componentHTML) {
        this.forms[componentData.uid] = new EmbroideryForm(componentData.uid, formsConfigurations[componentData.component], $componentHTML);
    }

    getForm(id) {
        return this.forms[id];
    }

    /**
     * Return the forms of a section as an array
     * @returns {Array} - forms array
     */
    getForms() {
        return Object.keys(this.forms).map(key => {
            return this.forms[key];
        });
    }

    /**
     * Returns the next step needed to progress the form
     * @returns {Object} - The missing step
     */
    getNextStep() {
        let forms = this.getForms();
        let form = forms.find(e => e.complete === false);
        let formField = form ? form.steps.find(e => e.complete === false) : null;

        return formField;
    }

    /**
     * Returns the previous step of the form
     * @returns {Object} - The missing step
     */
    getPreviousStep() {
        let forms = this.getForms();
        let nextIndex = forms[0].steps.findIndex(e => e.complete === false);
        return forms[0].steps[nextIndex - 1];
    }

    /**
     * Validates every field in every form in a section
     * and highlights errors on the field
     */
    validateSectionFields() {
        let forms = this.getForms();

        forms.forEach(form => {
            form.steps.every(step => {
                if (!step.complete && step.required) {
                    step.setError();
                    return false;
                }
                return true;
            });
        });
    }

    clearForms() {
        let forms = this.getForms();

        forms.forEach(form => {
            form.steps.forEach(step => {
                if (!step.complete) {
                    step.clearError();
                }
            });
        });
    }

    clearFormErrors(id) {
        let form = this.forms[id];

        form.steps.forEach(step => {
            step.clearError();
        });
    }
}

// Class representing the UI of the embroidery module. Has helper methods for accessing sections, forms, fields and manipulating the DOM
// It is separated from "Embroidery Data" object as the "Embroidery Data" gets used for ordering and should be clean.
class EmbroideryUi {
    constructor(componentsData) {
        var sortVals = {
            TEXT: 1,
            STOCK: 2,
            CUSTOMLOGO: 3,
            FLAG: 4,
            TEMPLATE: 5
        };
        this.orderedSections = ['TEMPLATE'];

        this.sections = {};
        this.currentSection = null;

        if (componentsData) {
            let keys = Object.keys(componentsData);
            for (let i = 0; i < keys.length; i++) {
                const component = componentsData[keys[i]];
                const type = component.componentId;
                this.sections[type] = new EmbroideryFormSection($(`.embroidery-section[data-section="${type}"]`), type);
                if (type !== 'COMMENTS') {
                    this.orderedSections.push(type); // add to ordered lists
                }
            }
        }

        this.orderedSections = this.orderedSections.sort((a, b) => {
            return sortVals[a] - sortVals[b];
        });
    }

    get valid() {
        let keys = Object.keys(this.sections);

        return keys.every(key => this.sections[key].valid || this.sections[key].untouched);
    }

    /**
     * Returns the number of completed embroidery sections
     * @type {number}
     */
    get completeCount() {
        let keys = Object.keys(this.sections);
        let count = 0;

        for (let i = 0; i < keys.length; i++) {
            const section = this.sections[keys[i]];

            if (section.valid && !section.untouched) {
                count++;
            }
        }

        return count;
    }

    addForm(config) {
        if (config.type) {
            this.sections[config.type].addForm(config);
        }
    }

    deleteForm(id) {
        let section = this.getSection(id);

        if (section && section.forms[id]) {
            delete section.forms[id];

            // Section can become valid after an incomplete form is deleted
            $(document).trigger('embroidery:sectionValidity', section);
        }
    }

    remove(id) {
        let section = this.getSection(id);

        if (section && section.forms[id]) {
            section.forms[id].$el.remove();
            delete section.forms[id];
            $(document).trigger('embroidery:sectionValidity', section);
        }
    }

    setComplete(step, id, state) {
        let section = this.getSection(id);

        if (section) {
            let form = section.getForm(id);

            if (form) {
                form.setComplete(step, state);

                // When updating a field, also check the entire section validity
                $(document).trigger('embroidery:sectionValidity', section);
            }
        }
    }

    /**
     * Searches all the sections and returns a form data object using it's id
     * @param {string} id - the id of the form
     * @returns {Object} - the form data object
     */
    getForm(id) {
        let keys = Object.keys(this.sections);
        let embroideryForm;
        for (let i = 0; i < keys.length; i++) {
            const section = this.sections[keys[i]];
            embroideryForm = section.getForm(id);

            if (embroideryForm) {
                break;
            }
        }

        return embroideryForm;
    }

    getField(id, key) {
        let form = this.getForm(id);

        if (form && form.steps) {
            return form.steps.find(step => step.id === key);
        }

        return undefined;
    }

    /**
     * Returns the section that contains the specified form using the form's id
     * @param {string} id - the id of the form
     * @returns {Object} - the section data object
     */
    getSection(id) {
        let keys = Object.keys(this.sections);
        let embroideryForm;
        for (let i = 0; i < keys.length; i++) {
            const section = this.sections[keys[i]];
            embroideryForm = section.getForm(id);
            if (embroideryForm) {
                return section;
            }
        }

        return undefined;
    }

    setWarning(componentId, uiField, msg) {
        let field = this.getField(componentId, uiField.id);
        if (field) {
            field.setWarning(msg);
        }

        $(document).trigger('embroidery:warning');
    }

    setError(componentId, uiField, msg) {
        let field = this.getField(componentId, uiField.id);
        if (field) {
            field.setWarning(msg);
        }

        $(document).trigger('embroidery:error');
    }

    /**
     * Returns an array of sections that have issues
     * @returns {Array} - the array of sections
     */
    getSectionsWithIssues() {
        let keys = Object.keys(this.sections);
        let sections = [];

        for (let i = 0; i < keys.length; i++) {
            const section = this.sections[keys[i]];
            if (section.hasWarning || section.hasError) {
                sections.push(section);
            }
        }

        return sections;
    }

    /**
     * Returns an array of forms that have issues
     * @returns {Array} - the array of forms
     */
    getFormsWithIssues() {
        let keys = Object.keys(this.sections);
        let forms = [];

        for (let i = 0; i < keys.length; i++) {
            const section = this.sections[keys[i]];
            const sectionForms = section.getForms();
            sectionForms.forEach(form => {
                if (form.hasWarning || form.hasError) {
                    forms.push(form);
                }
            });
        }

        return forms;
    }
}

class Contrast {
    static getLuminance(r, g, b) {
        let a = [r, g, b].map(function (v) {
            let value = v / 255;
            return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
        });
        return (a[0] * 0.2126) + (a[1] * 0.7152) + (a[2] * 0.0722);
    }

    static getLuminanceRatio(rgb1, rgb2) {
        let lum1 = Contrast.getLuminance(rgb1[0], rgb1[1], rgb1[2]);
        let lum2 = Contrast.getLuminance(rgb2[0], rgb2[1], rgb2[2]);
        let brightest = Math.max(lum1, lum2);
        let darkest = Math.min(lum1, lum2);
        return (brightest + 0.05) / (darkest + 0.05);
    }

    static hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        let hexValue = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexValue);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    static getValidContrast(base, color) {
        let baseHex = Contrast.hexToRgb(base);
        let rgbColor = Contrast.hexToRgb(color);
        let contrast = Contrast.getLuminanceRatio([baseHex.r, baseHex.g, baseHex.b], [rgbColor.r, rgbColor.g, rgbColor.b]);
        return contrast >= 1.4;
    }
}

/**
* A jquery extension that replaces html with dynamic data
* @param {Object} data - The data template, key is target element, value will be replaced
* @param {Object} target - If provided, will append element to target
* @returns {Object} The jquery object
*/
$.fn.renderTemplate = function (data, target) {
    let $this = $(this);
    let keys = Object.keys(data);

    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const html = data[key];

        if (html && key) {
            // Check if call was done on a parent element or the element itself
            if ($(this).is(`[data-template="${key}"]`)) {
                $this.html(html);
            } else {
                $this.find(`[data-template="${key}"]`).html(html);
            }
        }
    }

    if (target && target.length) {
        $this.appendTo(target);
    }

    return $this;
};

/**
* Adds DOM reactivity to a js property
* @param {string} propName - The property name
*/
function setReactiveProperty(propName) {
    Object.defineProperty(this, propName, {
        get: function () {
            return this[`_${propName}`];
        },
        set: function (value) {
            let $domNode = $(`[reactive="${propName}"]`);

            if ($domNode && $domNode.length) {
                $domNode.text(value);
            }
            this[`_${propName}`] = value;
        }
    });
}

/**
* Replaces {x} tags in a string with provided values
* @param {Object} data - The tag-value dictionary
* @param {string} str - The string to replace
* @returns {string} text - The modified string
*/
function replaceTags(data, str) {
    let text = str;
    if (text && data && Object.keys(data).length) {
        let keys = Object.keys(data);

        keys.forEach(key => {
            let value = data[key];
            let regex = new RegExp(`{(${key})*?}`, 'gi');
            if (value !== undefined) {
                text = text.replace(regex, value);
            }
        });
    }

    return text;
}

module.exports = {
    EmbroideryData,
    EmbroideryUi,
    Contrast,
    setReactiveProperty,
    replaceTags
};
